// app/plugins/02.chunk-recovery.client.js 處理 A 類 chunk 損壞時，在錯誤物件上標記本頁的復原狀態，
// sentry.client.config.ts 的 beforeSend 依此分流上報（CLIENT-PWA-SSR-8Q）。屬性名與狀態值只在此定義：
// 兩端各自手寫的話，任一側改名都不會報錯，只會讓分流靜默失效。
export const CHUNK_RECOVERY_STATUS = Object.freeze({
  // 本頁已觸發清快取重整，成敗要到重整後的新頁面才揭曉
  RELOADING: 'reloading',
  // session guard 已用掉，本頁不會再復原，使用者停在載入失敗的畫面
  EXHAUSTED: 'exhausted',
})

// V8 對 named export 對不上的措辭：單一一致 build 內不可能發生，必為新舊 build 混用（CLIENT-PWA-SSR-ZM），與截斷 /
// tokenize 失敗的位元組損壞根因不同。外掛的 A 類判定與 Sentry 的 EXHAUSTED 分組共用此定義，理由同上。
export const EXPORT_MISMATCH_RE = /does not provide an export named/i

export const markChunkRecoveryStatus = (error, status) => {
  error.chunkRecoveryStatus = status
}

export const getChunkRecoveryStatus = (error) => (error && typeof error === 'object' ? error.chunkRecoveryStatus : undefined)
